import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import * as Sentry from "@sentry/react";
import account, { track } from '@/controllers/account';
import Clarity from '@microsoft/clarity';
import Live2D from '@/controllers/Live2D';

Sentry.init({
  dsn: "https://22d5b4b45fba41feb6a764909dce9627@o4509931738300416.ingest.us.sentry.io/4509931744133120",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
      autoInject: false
    }),
    Sentry.browserTracingIntegration()
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^.*soclearn.org/, /^\//],
});

Clarity.init("t52wwz56er");

account.init();
Live2D.init();
track();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);